import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urls } from 'assets/url/urls';
import { LoginService } from '../../login/login.service';
import { Observable } from 'rxjs';
import { dateToStringInLocaleTZ } from 'app/shared/utils/utilBoostrap';
import { DashboardCalendarStats, DashboardCalendarStatsOfMonths } from 'app/model/dashboardCalendar';
import { DashboardEmployee } from 'app/model/dashboardEmployee';

@Injectable({
  providedIn: 'root'
})
export class AdminDashboardService {
  private readonly REST_API_SERVER = `${urls.baseUrl}/admin_dashboard`
  private readonly HEADERS = new HttpHeaders({
    'X-TENANT-ID': urls.tenant,
    'Authorization': 'Bearer ' + this.loginService.getToken()
  })

  /**
   * Constructor
   *
   * @param {HttpClient} http
   * @param {LoginService} loginService
   * 
  */
  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  public getDashboardCalendarStatsByDateRange(startDate: Date | null, endDate: Date | null)
    : Observable<DashboardCalendarStats> {
    const headers = this.HEADERS

    let params: HttpParams = new HttpParams()

    if (startDate) params = params.set('startDate', dateToStringInLocaleTZ(startDate))
    if (endDate) params = params.set('endDate', dateToStringInLocaleTZ(endDate))

    return this.http.get<DashboardCalendarStats>(`${this.REST_API_SERVER}/calendar/stats`, { headers, params })
  }

  public getDashboardCalendarStatsByDateRangeAndDptId(dptId: number, startDate: Date | null, endDate: Date | null)
    : Observable<DashboardCalendarStats> {
    const headers = this.HEADERS

    let params: HttpParams = new HttpParams()

    if (startDate) params = params.set('startDate', dateToStringInLocaleTZ(startDate))
    if (endDate) params = params.set('endDate', dateToStringInLocaleTZ(endDate))

    return this.http.get<DashboardCalendarStats>(
      `${this.REST_API_SERVER}/calendar/stats/department/${dptId}`,
      { headers, params }
    )
  }

  public getDashboardCalendarStatsByDateRangeAndEmployeeId(employeeId: number, startDate: Date | null, endDate: Date | null)
    : Observable<DashboardCalendarStats> {
    const headers = this.HEADERS

    let params: HttpParams = new HttpParams()

    if (startDate) params = params.set('startDate', dateToStringInLocaleTZ(startDate))
    if (endDate) params = params.set('endDate', dateToStringInLocaleTZ(endDate))

    return this.http.get<DashboardCalendarStats>(
      `${this.REST_API_SERVER}/calendar/stats/employee/${employeeId}`,
      { headers, params }
    )
  }

  public getDashboardCalendarStatsOfMonthsByDateRange(startDate: Date | null, endDate: Date | null)
    : Observable<DashboardCalendarStatsOfMonths> {
    const headers = this.HEADERS

    let params: HttpParams = new HttpParams()

    if (startDate) params = params.set('startDate', dateToStringInLocaleTZ(startDate))
    if (endDate) params = params.set('endDate', dateToStringInLocaleTZ(endDate))

    return this.http.get<DashboardCalendarStatsOfMonths>(`${this.REST_API_SERVER}/calendar/stats/month`, { headers, params })
  }

  public getDashboardCalendarStatsOfMonthsByDateRangeAndDptId(dptId: number, startDate: Date | null, endDate: Date | null)
    : Observable<any> {
    const headers = this.HEADERS

    let params: HttpParams = new HttpParams()

    if (startDate) params = params.set('startDate', dateToStringInLocaleTZ(startDate))
    if (endDate) params = params.set('endDate', dateToStringInLocaleTZ(endDate))

    return this.http.get<DashboardCalendarStatsOfMonths>(
      `${this.REST_API_SERVER}/calendar/stats/month/department/${dptId}`,
      { headers, params }
    )
  }

  public getDashboardCalendarStatsOfMonthsByDateRangeAndEmployeeId(employeeId: number, startDate: Date | null, endDate: Date | null)
    : Observable<any> {
    const headers = this.HEADERS

    let params: HttpParams = new HttpParams()

    if (startDate) params = params.set('startDate', dateToStringInLocaleTZ(startDate))
    if (endDate) params = params.set('endDate', dateToStringInLocaleTZ(endDate))

    return this.http.get<DashboardCalendarStatsOfMonths>(
      `${this.REST_API_SERVER}/calendar/stats/month/employee/${employeeId}`,
      { headers, params }
    )
  }

  public getDashboardCalendarStatsOfMonthsAndEmployeesByDateRange(startDate: Date | null, endDate: Date | null)
    : Observable<DashboardCalendarStatsOfMonths> {
    const headers = this.HEADERS

    let params: HttpParams = new HttpParams()

    if (startDate) params = params.set('startDate', dateToStringInLocaleTZ(startDate))
    if (endDate) params = params.set('endDate', dateToStringInLocaleTZ(endDate))

    return this.http.get<DashboardCalendarStatsOfMonths>(
      `${this.REST_API_SERVER}/calendar/stats/month/employee/count`,
      { headers, params }
    )
  }

  public getDashboardCalendarStatsOfMonthsAndEmployeesByDateRangeAndDptId(dptId: number, startDate: Date | null, endDate: Date | null)
    : Observable<any> {
    const headers = this.HEADERS

    let params: HttpParams = new HttpParams()

    if (startDate) params = params.set('startDate', dateToStringInLocaleTZ(startDate))
    if (endDate) params = params.set('endDate', dateToStringInLocaleTZ(endDate))

    return this.http.get<DashboardCalendarStatsOfMonths>(
      `${this.REST_API_SERVER}/calendar/stats/month/employee/count/department/${dptId}`,
      { headers, params }
    )
  }

  public getDashboardEmployeeById(employeeId: number): Observable<DashboardEmployee> {
    const headers = this.HEADERS

    return this.http.get<DashboardEmployee>(`${this.REST_API_SERVER}/employee/${employeeId}`, { headers })
  }
}
